import MyExpApi from "apps/myExperience/enum/MyExpApi";
import ParticipantSubRole from "shared/enums/ParticipantSubRole";
import { ApiNonAttendeeApplicationResponse } from "shared/types/ApiNonAttendeeApplicationResponse";
import { useGetApiData } from "shared/datalayer";

export function useGetNonAttendeeUnapprovedHistory({
  applicantId,
  participantSubRole
}: {
  applicantId?: string;
  participantSubRole?: ParticipantSubRole;
}) {
  return useGetApiData<Array<ApiNonAttendeeApplicationResponse>>(
    MyExpApi.FIND_NON_ATTENDEE_UNAPPROVED_APPLICATION_HISTORY,
    {
      params: { applicantId, participantSubRole }
    },
    {
      enabled: Boolean(applicantId) && Boolean(participantSubRole)
    }
  );
}
